import { getRequest } from "..";

const apiUrlMultivac = process.env.REACT_APP_MULTIVAC_URL;

export interface SeoReportTask {
    id: number;
    created_at: string;
    parameters: {
        month: string;
    };
}

export type SeoReportList = SeoReportTask[];

export const getSeoReportList = async (email: string, token: string): Promise<SeoReportList> => {
const endpoint = `${apiUrlMultivac}/seo-report/list?email=${email}`;
  try {
    const result = await getRequest(endpoint, token);
    console.log(result);
    return result as unknown as SeoReportList;
  } catch (error) {
    console.error('Error fetching SEO report list:', error);
    throw error;
  }
};

export const getSeoReportByMonth = async (email: string, reportId: number, token: string): Promise<SeoReportResponse> => {
  const endpoint = `${apiUrlMultivac}/seo-report/view?email=${email}&report_id=${reportId}`;

  try {
    const result = await getRequest(endpoint, token);
    console.log(result);
    return result;
  } catch (error) {
    console.error('Error fetching SEO report by month:', error);
    throw error;
  }
};


export interface SeoReportResponse {
    "performance-report": PerformanceReport[];
    "keyword-report": KeywordReport[];
    "share-of-voice-report": ShareOfVoiceReport[];
  }
  
  export interface PerformanceReport {
    task_id: number;
    leads: number;
    leads_column_name: string;
    targets: Record<string, string | number>[];
    traffic: number;
    bofu_traffic: number | null;
    bofu_impression: number | null;
    graph_data: Record<string, GraphData>;
    mom_trend: Record<string, MomTrend>;
    category_trend: Record<string, CategoryTrend>;
    tech_issue: Record<string, Record<string, number>>;
    id: number;
  }
  
  interface GraphData {
    group1: number;
    group2: number;
  }
  
  interface MomTrend {
    leads: number;
    all_clicks: number;
    leads_change: string;
    branded_clicks: number;
    all_clicks_change: string;
    non_branded_clicks: number;
    branded_clicks_change: string;
    non_branded_clicks_change: string;
  }
  
  export interface CategoryTrend {
    leads: Record<string, number>;
    traffic: Record<string, number>;
    traffic_change?: Record<string, string>;
  }
  
  export interface KeywordReport {
    task_id: number;
    keyword_data: KeywordData[];
  }
  
  export interface KeywordData {
    keyword: string;
    position: Record<string, number>;
    demoPotential: string;
    pageTargetingKeyword: string;
  }
  
  export interface TableEntry {
    category: string;
    leads: number;
    traffic: number;
    no_of_pages: number;
    backlinks: number;
  }
  
  export interface ShareOfVoiceReport {
    traffic_pie_chart: Chart[];
    graphs: SeoGraphs;
    refined_table: Table;
    table: Table;
  }
  
  export interface Chart {
    competitor_name: string;
    competitor_domain: string;
    pie_chart_data: PieChart;
  }
  export interface SeoGraphs {
    pages: string;
    traffic: string;
    backlinks: string;
    bofuTraffic: string;
    keywordRankingUnder10: string;
    bofuKeywordImpressions: string;
  }
  
  export interface Table {
    page_type: TableEntry[];
    topics: TableEntry[];
    persona: TableEntry[];
    business_segment: TableEntry[];
  }
  
  export interface PieChart {
    traffic: number;
    bofu_traffic: number;
  }
  